import React from 'react';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faFont, faTimes, faSortNumericDown, faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons'
import { faPlusSquare, faMinusSquare, faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons'
import jmespath from 'jmespath'
const axios = require('axios');


const example = {
  string: 'hello',
  integer : 1,
  array: [1,2,3],
  boolean:true,
  boolean2:false,
  float:0.024,
  object:{
    a:1,
    b:{
      yes:'yes',
      "deeper":[1,2,3]
    },c:3,d:null}

};

class App extends React.Component{
  constructor(props){
      super(props);
      this.state = {
        source: example,
        sourceInput: null,
        isValid:true,
        filterExpression: ''
      };
      this.state.sourceInput = JSON.stringify(this.state.source, null, 2);
      this.handleSourceChange = this.handleSourceChange.bind(this);
      this.applyFilterExpression = this.applyFilterExpression.bind(this);

  }

  componentDidMount(){
    var self = this;

    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('from')) {
      console.info('Load from ' + urlParams.get('from'));
      self.setState({source: {"loading_from":urlParams.get('from')}, sourceInput: JSON.stringify({"loading_from":urlParams.get('from')}, null, 2)});

      axios.get(urlParams.get('from'))
        .then(function (response) {
          self.setState({source: response.data, sourceInput: JSON.stringify(response.data, null, 2)});
          // handle success
          console.log(response);
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    }
  }

  applyFilterExpression(e){
    this.setState({filterExpression:e.target.value || ""});
  }

  handleSourceChange(e){
    let isValid = false;
    try{
      const newSauce = JSON.parse(e.target.value);
      if(newSauce && newSauce !== this.state.source){
        isValid = true;
        this.setState({source:newSauce});
      }
    }catch (e) {
      // error
    }
    this.setState({sourceInput:e.target.value, isValid:isValid});

  }

  render(){
    return (
        <div className="App">
          <ToolRow filterExpression={this.state.filterExpression} applyFilterExpression={this.applyFilterExpression} />
          <div className="panels">
            <SourcePanel isValid={this.state.isValid} sourceChange={this.handleSourceChange} source={this.state.sourceInput}>SAUCE</SourcePanel>
            <SourceExplorer filterExpression={this.state.filterExpression} applyFilterExpression={this.applyFilterExpression} source={this.state.source}>EXPLORER</SourceExplorer>
          </div>
          <footer>JSON Object Explorer by <a href="http://karlhennigan.com/" target="_blank" rel="noreferrer noopener">Karl Hennigan</a> | Made with REACT</footer>
        </div>
    );
  }
}

class ToolRow extends React.Component {
  constructor(props){
    super(props);
    this.state = {isOpen:false};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    this.setState({isOpen: !this.state.isOpen});
  }
  render() {
    let button = (this.state.isOpen) ? <button className="clickable toolbar-toggle form-input" onClick={this.handleClick}>Close <FontAwesomeIcon icon={faCaretUp} /></button> : <button className="clickable toolbar-toggle form-input" onClick={this.handleClick}>Open <FontAwesomeIcon icon={faCaretDown} /></button>;

    return (
        <div>
          <div className="ToolRowHeader">Tools {button}</div>
          {(this.state.isOpen) ? <ToolBox filterExpression={this.props.filterExpression} onChange={this.props.applyFilterExpression} />:''}
        </div>
    );

  }
}

function ToolBox(props) {
  return (
      <div className="ToolBox">
        <div>
          <label htmlFor="expressionFilter">Filter Expression: </label>
          <input className="form-input" id="expressionFilter" name="expressionFilter" onChange={props.onChange} value={props.filterExpression} />
          <select disabled className="form-input"><option>JMESPath</option></select>
        </div>
      </div>
  )

}


class SourcePanel extends React.Component {

  render() {

    return (
        <div className="panel source">
          <h3>Source</h3>
          <textarea className={this.props.isValid ? 'valid' : 'invalid'} value={this.props.source} onChange={this.props.sourceChange} />
        </div>
    );
  }
}


class SourceExplorer extends React.Component {
  render() {
    let source = this.props.source;
    let filterError = '';
    if(this.props.filterExpression){
      try{
        source = jmespath.search(source, this.props.filterExpression);
      }catch (e) {
        // Invalid filter
        filterError = e.toString();
      }
    }
    let items = [];

    if (typeof  source === "object") {
      for(let prop in source){
        items.push(<PropertyContainer key={"_"+prop} depth="0" pname={prop} prop={source[prop]} />);
      }
    } else {
      items.push(<PropertyContainer key="_root" depth="0" pname="root primitive" prop={source} />);
    }
    return (
        <div className="panel explorer">
          <h3>SourceExplorer</h3>
          <ExplorerStatus applyFilterExpression={this.props.applyFilterExpression} error={filterError} filterExpression={this.props.filterExpression} />
          <div className="itemList">
          {items}
          </div>
        </div>
    );
  }
}

function ExplorerStatus(props){
  return (
      <div>
        {props.filterExpression ? (<div className="filterExpression">
          <strong>Filter Expression</strong>: <em className="message">{props.filterExpression}</em>
          <button className="clickable form-input" onClick={props.applyFilterExpression} value={""} style={{float:'right'}}>Remove  <FontAwesomeIcon icon={faTimes} /></button>
        </div>) : ''}
        {props.error ? <div className="filterError"><strong>Expression Error</strong>: <em className="message">{props.error}</em></div>:''}
      </div>
  );
}

class PropertyContainer extends React.Component{
  render(){
    var type = typeof(this.props.prop);
    if(this.props.prop == null){
      type = 'null';
    }else if(type === 'object' && Array.isArray(this.props.prop)){
      type = 'array';
    }
    var item = '';

    switch(type){
      case 'null':
        item = <Null type={type} key={this.props.pname} pname={this.props.pname} value={this.props.prop} depth={(parseInt(this.props.depth) || 0)+1} />;
        break;
      case 'number':
      case 'boolean':
      case 'string':
        item = <Scalar type={type} key={this.props.pname} pname={this.props.pname} value={this.props.prop} depth={(parseInt(this.props.depth) || 0)+1} />;
        break;
       case "object":
       case "array":
         item = <Collection type={type} key={this.props.pname} pname={this.props.pname} value={this.props.prop} depth={(parseInt(this.props.depth) || 0)+1} />;
         break;
      default:
        break;
    }

    return (
        <div className="item">
          {item}
        </div>
    );
  }
}

class Null extends React.Component{
  render() {

    return <div className="itemField"><FontAwesomeIcon icon={faTimes} /> <em>"{this.props.pname}" = ({this.props.type})</em></div>;
  }
}

class Scalar extends React.Component{

  render() {

    let value = this.props.value;
    let icon = <FontAwesomeIcon icon={faSortNumericDown} />;
    if(this.props.type === "boolean"){
      icon = (value) ? <FontAwesomeIcon icon={faCheckSquare} /> : <FontAwesomeIcon icon={faSquare} /> ;
      value = (value) ? "true" : "false";

    }else if (this.props.type === "string"){
      value = '"'+value+'"';
       icon = <FontAwesomeIcon icon={faFont} />;
    }
    return <div className="itemField">{icon} <em>({this.props.type})</em> "{this.props.pname}" = {value}</div>;
  }
}

class Collection extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      isOpen : false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    this.setState({isOpen: !this.state.isOpen});
  }

  render() {
    let icon = (this.state.isOpen) ? <FontAwesomeIcon icon={faMinusSquare} /> : <FontAwesomeIcon icon={faPlusSquare} /> ;

    let items = [];
    let childCount = Object.values(this.props.value).length;
    if(this.state.isOpen){
      if (this.props.value) {
        for (let prop in this.props.value) {
          items.push(<PropertyContainer  key={prop} pname={prop} depth={this.props.depth} prop={this.props.value[prop]}/>);
        }
      }
    }
    return <div className="itemField collection"><a className="clickable" onClick={this.handleClick}><small className="childCount"><data value={childCount}>{childCount}</data> Children</small>{icon} <em>({this.props.type})</em> = "{this.props.pname}"</a> {items}</div>;
  }
}


export default App;
